// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta_cta__VQ29z","text":"Cta_text__QJ1Fu"};